import * as d3 from "d3";
import { changeSwarmBoxPlotOrder } from "@/components/VivoPlots/functions/utils/changePlotOrder";
import { drawSwarmPlot } from "@/components/VivoPlots/functions/drawPlotData/drawSwarplot";
import { drawBoxPlot } from "@/components/VivoPlots/functions/drawPlotData/drawBoxplot";
import { drawBars } from "./drawBars";
import { drawScatterPlot } from "@/components/VivoPlots/functions/drawPlotData/drawScatter";

export const drawData = async (
  plotClassName: string,
  data: any,
  scales: any,
  plotConfig: any,
  dimensions: any,
  type = "barplot",
) => {
  if (type === "barplot") {
    drawBars(
      plotConfig.plotClassName,
      data.stackedData,
      scales,
      "value",
      plotConfig.groupLegendPostscript,
      data.subjectData,
      plotConfig,
    );
  }
  if (type === "scatter") {
    await drawScatterPlot(plotClassName, data.data, scales, plotConfig);
  }

  if (type === "swarm-box") {
    if (plotConfig.showSwarm) {
      await drawSwarmPlot(plotClassName, data.nestedData, scales, plotConfig);
    }
    drawBoxPlot(plotClassName, data.nestedData, scales, plotConfig);
    drawBetweenPlotPanel(plotClassName);
    changeSwarmBoxPlotOrder(plotClassName, plotConfig.isBoxplotInFront);
  }
};

const drawBetweenPlotPanel = (plotClassName: string) => {
  const svg = d3.select(`svg.${plotClassName}`);
  const betweenPlotPanel = svg
    .selectAll("g.between-plot-panel")
    .data([null])
    .join("g")
    .attr("class", "between-plot-panel");
  betweenPlotPanel
    .selectAll("rect")
    .data([null])
    .join("rect")
    .attr("width", "100%")
    .attr("height", "100%")
    .attr("fill", "transparent");
};
